import { MicrosoftAccessCopySink } from 'app/model/pipeline/copysink/microsoft-access.copysink';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { Model } from 'app/model/backendmodel';
import { CopySinkAdapter } from './copysink.adapter';
import { Metamodel } from 'app/model/base/model';
import { Owned } from 'app/model/base/named';
import { AdapterRegistry } from 'shell-models-lib';
import { Activity } from 'app/model/pipeline/activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MicrosoftAccessCopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBatchSize: '*',
        writeBatchTimeout: '*',
        preCopyScript: '*',
        maxConcurrentConnections: '*'
    }
})
export class MicrosoftAccessSinkAdapter extends TabularSinkAdapter<MicrosoftAccessCopySink, Model.CopySink> {
    protected override async _toResource(model: MicrosoftAccessCopySink): Promise<Model.CopySink> {
        const resource = CopySinkAdapter.getCommonCopySinkProperties(
            model,
            Metamodel.modelFor(MicrosoftAccessCopySink).name
        );
        if (model != null) {
            TabularSinkAdapter.toSinkResource(model, resource);
            CopySinkAdapter.toCommonCopySinkResource(model, resource, this.context);
        }
        return resource;
    }

    protected override async _toModel(resource: Model.CopySink, owner: Activity): Promise<MicrosoftAccessCopySink> {
        const model = Owned.create<MicrosoftAccessCopySink>(Metamodel.modelFor(MicrosoftAccessCopySink), owner);
        if (resource != null) {
            TabularSinkAdapter.toSinkModel(resource, model);
            CopySinkAdapter.toCommonCopySinkModel(model, resource);
        }
        return model;
    }
}
